  <template>
    <div>
      <div class="overlaytool">
        <div class="overlaytool_wrapper">
          <div class="overlaytool_left">
            <h2 class="overlaytool_title">{{ messages.blockOneTitle }}</h2>
            <div>
              <div class="block-one">
                <h4 class="overlaytool_secondarytitle">
                  {{ messages.blockOneSecondaryTitle }}
                </h4>
                <p class="overlaytool_desc">{{ messages.blockOnePMessage }}</p>
                <div class="form-group">
                  <input type="text" class="form-control" onfocus="this.placeholder=''"
                    onblur="this.placeholder='SVG URL'" placeholder="SVG URL" v-model="svgUrl" />
                </div>
              </div>
              <div class="block-two">
                <h4 class="overlaytool_secondarytitle">
                  {{ messages.blockTwoSecondaryTitle }}
                </h4>
                <p class="overlaytool_desc">{{ messages.blockTwoPMessage }}</p>
                <div>
                  <div class="form-group">
                    <p class="overlaytool_desc">
                      {{ messages.communityCode }}
                    </p>
                    <input type="text" class="form-control" onfocus="this.placeholder=''"
                      onblur="this.placeholder='Community Code'" placeholder="Community Code" v-model="communityCode" />
                  </div>

                  <div class="form-group" v-if="!!communityCode">
                    <button class="btn" style="margin-left: auto" @click="getCommunityNeighborhoods" :disabled="loading">
                      Get Neigbourhoods
                      <span class="icon icon-right-white-arrow"></span>
                    </button>
                  </div>

                  <div class="form-group" v-if="neighborhoods.length">
                    <p class="overlaytool_desc">Neighborhoods :</p>
                    <select class="form-control overlaytool_formcontrol" @change="updateSelectedNeighborhood"
                      v-model="neighbourhood">
                      <option disabled value="0">Choose</option>
                      <option v-for="neighbourhood in neighborhoods" :value="neighbourhood.id" :key="neighbourhood.id">
                        {{ neighbourhood.neighborhood_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="overlaytool_coordinates">
                  <div class="ne-corner">
                    <h5 class="overlaytool_coordinates_title">
                      {{ messages.neCorner }}
                    </h5>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control" placeholder="NE Corner Latitude"
                        v-model="NECornerLatitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='NE Corner Latitude'" />
                    </div>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control"
                        placeholder="NE Corner Longitude" v-model="NECornerLongitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='NE Corner Longitude'" />
                    </div>
                  </div>
                  <div class="centerpoint">
                    <h5 class="overlaytool_coordinates_title">
                      {{ messages.centerPoint }}
                    </h5>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control"
                        placeholder="Centerpoint Latitude" v-model="CenterpointLatitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='Centerpoint Latitude'" />
                    </div>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control"
                        placeholder="Centerpoint Longitude" v-model="CenterpointLongitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='Centerpoint Longitude'" />
                    </div>
                  </div>
                  <div class="sw-corner">
                    <h5 class="overlaytool_coordinates_title">
                      {{ messages.swCorner }}
                    </h5>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control" placeholder="SW Corner Latitude"
                        v-model="SWCornerLatitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='SW Corner Latitude'" />
                    </div>
                    <div class="form-group">
                      <input :disabled="!!communityCode" type="text" class="form-control"
                        placeholder="SW Corner Longitude" v-model="SWCornerLongitude" onfocus="this.placeholder=''"
                        onblur="this.placeholder='SW Corner Longitude'" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <h5 class="overlaytool_desc">
                  {{ messages.zoom }}
                </h5>
                <div class="form-group">
                  <input @change="updateZoomLevel" type="number" class="form-control" placeholder="Zoom" v-model="zoom"
                    onfocus="this.placeholder=''" onblur="this.placeholder='Zoom'" />
                </div>
              </div>

              <div class="form-group" style="display: flex">
                <button class="btn" style="margin-left: auto" @click="submitPreviewData" :disabled="loading">
                  Show preview
                  <span class="icon icon-right-white-arrow"></span>
                </button>
              </div>
              <div class="form-group">
                <div class="is-error" v-for="error in errors" v-bind:key="error">
                  · {{ error }}
                </div>
              </div>
            </div>
          </div>
          <div class="overlaytool_right">
            <!--loader-->
            <div class="loading-overlay" v-if="loading">
              <div :class="!!loading ? 'loading' : ''"></div>
            </div>
            <!--loader-->
            <div v-if="showPreview" class="embtoolbox">
              <div class="emb-card">
                <div class="tbIcon embtoolbox_in" @click="svgZoomIn"></div>
                <div class="tbIcon embtoolbox_out" @click="svgZoomOut"></div>
              </div>
            </div>
            <MapPreview ref="mapPreview" v-if="showPreview" :svgUrl="svgUrl" :NECornerLatitude="NECornerLatitude"
              :NECornerLongitude="NECornerLongitude" :CenterpointLatitude="CenterpointLatitude"
              :CenterpointLongitude="CenterpointLongitude" :SWCornerLatitude="SWCornerLatitude"
              :SWCornerLongitude="SWCornerLongitude" :mapZoom="+zoom" @changeZoomLevel="changeZoomLevel" />
          </div>
        </div>
      </div>

      <!--geo positioning html-->
      <div class="overlaytool geoposition" style="display: none">
        <div class="overlaytool_wrapper">
          <div class="overlaytool_left">
            <div class="block-one">
              <h2 class="overlaytool_title">
                {{ messages.geoPositioningTitle }}
              </h2>
              <h4 class="overlaytool_secondarytitle">
                {{ messages.geoPositioningSecondaryTitle }}
              </h4>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Search by landmark, address, ZIP code, etc."
                  onfocus="this.placeholder=''" onblur="this.placeholder='Search by landmark, address, ZIP code, etc.'" />
                <span class="search-icon"></span>
              </div>
            </div>
            <div class="block-two">
              <h4 class="overlaytool_secondarytitle">
                {{ messages.geoPositioningH4Message }}
              </h4>
              <p class="overlaytool_desc">
                {{ messages.geoPositioningP1Message }}
              </p>
              <p>{{ messages.geoPositioningP2Message }}</p>
              <div class="overlaytool_coordinates">
                <div class="ne-corner">
                  <h5 class="overlaytool_coordinates_title">
                    {{ messages.neCorner }}
                  </h5>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="30.611895" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="-97.850491" />
                  </div>
                </div>
                <div class="centerpoint">
                  <h5 class="overlaytool_coordinates_title">
                    {{ messages.cornerPoint }}
                  </h5>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="30.611895" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="-97.850491" />
                  </div>
                </div>
                <div class="sw-corner">
                  <h5 class="overlaytool_coordinates_title">
                    {{ messages.swCorner }}
                  </h5>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="30.611895" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="-97.850491" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group" style="display: flex">
              <button class="btn" style="margin-left: auto">
                Copy coordinates (JSON)
                <span class="file-icon">
                  <img src="../../assets/images/file-json.png" />
                </span>
              </button>
              <button class="clear-all-btn">Clear All</button>
            </div>
          </div>
          <div class="overlaytool_right">
            <div class="embtoolbox">
              <div class="emb-card">
                <div class="tbIcon embtoolbox_in"></div>
                <div class="tbIcon embtoolbox_out"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--geo positioning html-->
    </div>
  </template>

  <script setup lang="ts">
  import { ref } from "vue"
  import MapPreview from "../MapPreview.vue";
  import { apiMessages } from "../../api/message-api";
  import { Settings } from "@/constant/enums";
  import { apiFetchNeighbourhoodsForPreview } from "../../api/preview-api";
  import { Community, Neighbourhood } from "../../types/preview";


  const loading = ref(false)
  const showPreview = ref(false)

  const selectedNeighborhood = ref({} as Neighbourhood)
  const neighborhoods = ref<Neighbourhood[]>([])
  const neighbourhood = ref("0")

  const svgUrl = ref("")
  const communityCode = ref("")
  const NECornerLatitude = ref("")
  const NECornerLongitude = ref("")
  const CenterpointLatitude = ref("")
  const CenterpointLongitude = ref("")
  const SWCornerLatitude = ref("")
  const SWCornerLongitude = ref("")
  const zoom = ref<any>("")

  const errors = ref<string[]>([])
  const messages = ref<any>({})
  const validationMessages = ref<any>({})

  const fieldArr = [
    "svgUrl",
    "NECornerLatitude",
    "NECornerLongitude",
    "CenterpointLatitude",
    "CenterpointLongitude",
    "SWCornerLatitude",
    "SWCornerLongitude",
    "zoom",
  ]

  // 🔹 Template refs
  const mapPreview = ref<any>(null)

  // 🔹 Lifecycle: load messages on mount
  const loadMessages = async () => {
    const { messages: msg, validationMessage } = await apiMessages("PlatMapPreview")
    messages.value = msg
    validationMessages.value = validationMessage
  }
  loadMessages()

  // 🔹 Methods

  const updateSelectedNeighborhood = () => {
    const n = neighborhoods.value.find((n) => n.id === neighbourhood.value)
    if (n) {
      selectedNeighborhood.value = n
      CenterpointLatitude.value = n.latitude.toString()
      CenterpointLongitude.value = n.longitude.toString()
    }
  }

  const getCommunityNeighborhoods = async (e: Event) => {
    loading.value = true
    neighbourhood.value = "0"
    errors.value = []
    try {
      const response = await apiFetchNeighbourhoodsForPreview(communityCode.value)
      const result: Community = response.result

      if (!result.neighborhoods.length) {
        errors.value.push(validationMessages.value.noNeighborhoodFound)
      } else {
        neighborhoods.value = result.neighborhoods
        if (neighborhoods.value.length === 1) {
          neighbourhood.value = neighborhoods.value[0].id
        }
        NECornerLatitude.value = result.ne_corner_latitude.toString()
        NECornerLongitude.value = result.ne_corner_longitude.toString()
        CenterpointLatitude.value = result.center_latitude.toString()
        CenterpointLongitude.value = result.center_longitude.toString()
        SWCornerLatitude.value = result.sw_corner_latitude.toString()
        SWCornerLongitude.value = result.sw_corner_longitude.toString()
        zoom.value = result.zoom_level || Settings.MAP_DEFAULT_SVG_SCALE
      }
    } catch (err) {
      errors.value.push(validationMessages.value.validCommunityCode)
      neighborhoods.value = []
    }
    loading.value = false
  }

  const checkAllFieldsEmpty = () => {
    let isFieldEmpty = false
    for (const item of fieldArr) {
      if (!(getFieldValue(item))) {
        isFieldEmpty = true
      }
    }
    if (isFieldEmpty) {
      errors.value.push(validationMessages.value.emptyFields)
    }
  }

  const checkValidCoordinate = () => {
    let invalid = false
    for (const item of fieldArr) {
      if (item !== "svgUrl" && validateCoordinate(getFieldValue(item))) {
        invalid = true
      }
    }
    if (invalid) {
      errors.value.push(validationMessages.value.validCoordinates)
    }
  }

  const checkLongitude = () => {
    if (
      validateLongitude(NECornerLongitude.value) ||
      validateLongitude(CenterpointLongitude.value) ||
      validateLongitude(SWCornerLongitude.value)
    ) {
      errors.value.push(validationMessages.value.validLongitude)
    }
  }

  const updateZoomLevel = () => {
    errors.value = []
    checkAllFieldsEmpty()
    checkZoomValidation()
    if (!errors.value.length && showPreview.value) {
      svgZoom()
    }
  }

  const checkZoomValidation = () => {
    if (zoom.value && (zoom.value < 10 || zoom.value > 20)) {
      errors.value.push(validationMessages.value.validZoom)
    }
  }

  const submitPreviewData = () => {
    loading.value = true
    showPreview.value = false
    errors.value = []

    checkAllFieldsEmpty()
    checkValidCoordinate()
    checkLongitude()
    checkZoomValidation()
    console.log("errors view", errors.value)
    if (!errors.value.length) {
      const timer = setTimeout(() => {
        loading.value = false
        showPreview.value = true
        clearTimeout(timer)
      }, 1000)
    } else {
      loading.value = false
      showPreview.value = false
    }
  }

  const validateLongitude = (longitudeCoordinate: string) => {
    return longitudeCoordinate && !validateCoordinate(longitudeCoordinate)
      ? !longitudeCoordinate.startsWith("-")
      : false
  }

  const validateCoordinate = (val: string) => {
    return val ? !( !isNaN(parseFloat(val)) && isFinite(parseFloat(val)) ) : false
  }

  const changeZoomLevel = (zoomLevel: number) => {
    zoom.value = zoomLevel
  }

  // 🔹 Map Preview methods
  const svgZoom = () => {
    mapPreview.value?.svgZoom(+zoom.value)
  }
  const svgZoomIn = () => {
    mapPreview.value?.svgZoomIn()
  }
  const svgZoomOut = () => {
    mapPreview.value?.svgZoomOut()
  }

  // 🔹 Helper: get reactive value by field name
  function getFieldValue(field: string): any {
    switch (field) {
      case "svgUrl": return svgUrl.value
      case "NECornerLatitude": return NECornerLatitude.value
      case "NECornerLongitude": return NECornerLongitude.value
      case "CenterpointLatitude": return CenterpointLatitude.value
      case "CenterpointLongitude": return CenterpointLongitude.value
      case "SWCornerLatitude": return SWCornerLatitude.value
      case "SWCornerLongitude": return SWCornerLongitude.value
      case "zoom": return zoom.value
    }
  }
  </script>

  <style lang="scss" scoped>
  .platmap-error {
    position: fixed;
    top: 0;
    left: 0;
    background: lighten($black, 19);
    width: 100%;
    height: 100%;
    z-index: map-get($z-index, emberror-page);
    @extend %flex-allcenter;
    color: $white;
    overflow: hidden;

    .middle {
      max-width: 400px;
      padding: 0 20px;
      text-align: left;
    }

    h3 {
      color: #fb6363;
      font-weight: 600;
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 15px;
    }

    p {
      font-size: 14px;
      margin-bottom: 15px;
    }

    a {
      color: $secondary;
    }
  }

  .overlaytool {
    height: 100vh;

    &_wrapper {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
    }

    &_left {
      flex: 0 1 509px;
      padding: 20px 40px;
      background-color: $white;
      overflow-y: auto;
      height: 100vh;
      z-index: 100;
      position: relative;
    }

    &_right {
      flex: 0 0 calc(100% - 509px);
      position: relative;
      background-color: #ddd;

      #map {
        height: 100vh !important;
        position: absolute !important;
        width: calc(100vw - 510px);
      }
    }

    &_title {
      font-weight: 600;
      font-size: 29px;
      line-height: 39px;
      color: $light-green;
      margin-bottom: 25px;
    }

    &_secondarytitle {
      font-weight: 600;
      font-size: 21px;
      line-height: 29px;
      color: $light-green;
      margin-bottom: 10px;
    }

    &_desc {
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      color: $gray;
      margin-bottom: 15px;
    }

    &_formcontrol {
      appearance: auto;
    }

    .form-control {
      background-color: $white;
      border-width: 2px;

      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #979797;
      }

      &::-moz-placeholder {
        /* Firefox 19+ */
        color: #979797;
      }

      &:-ms-input-placeholder {
        /* IE 10+ */
        color: #979797;
      }

      &:-moz-placeholder {
        /* Firefox 18- */
        color: #979797;
      }
    }

    &_coordinates {
      border: 2px dashed #dadada;
      border-radius: 4px;
      width: 392px;
      height: 321px;
      max-width: 100%;
      max-height: 100%;
      margin: 60px auto 50px;

      >div {
        max-width: 215px;
        width: 100%;
      }

      &_title {
        font-weight: 700;
        font-size: 17px;
        line-height: 23px;
        color: #3e3e3e;
        margin-bottom: 6px;
        margin-left: 3px;
      }

      .ne-corner {
        margin: -48px -30px 0 auto;
      }

      .centerpoint {
        margin: auto;
      }

      .sw-corner {
        margin-right: auto;
        margin-left: -25px;
      }
    }

    .clear-all-btn {
      font-size: 18px;
      line-height: 18px;
      color: #f7931e;
      font-weight: 400;
      border: none;
      outline: none;
      background-color: transparent;
      margin-right: 20px;
      margin-left: 20px;
      cursor: pointer;
    }

    .search-icon {
      background: $white url("../../assets/images/search icon.png") no-repeat;
      width: 16px;
      height: 17px;
      cursor: pointer;
      transition: 0.2s all;
      display: inline-block;
      position: absolute;
      right: 10px;
      top: 11px;
    }

    .file-icon {
      display: inline-block;
      margin-left: 8px;
    }

    .block-one .form-group {
      margin-bottom: 30px;
    }
  }

  .embtoolbox {
    position: absolute;
    top: 6px;
    left: 6px;
    right: auto;

    .emb-card {
      padding: 10px 7.5px;
    }
  }
  </style>
